(() => {
  const sections = document.querySelectorAll('.article-grid--constrain');

  sections.forEach((section) => {
    if (section.dataset.initialized) {
      return;
    }

    section.dataset.initialized = 'true';

    const itemsCount = parseInt(section.dataset.itemsCount);

    const articles = Array.from(section.querySelectorAll('.grid > a'));

    // Fisher-Yates shuffle for randomization
    for (let i = articles.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [articles[i], articles[j]] = [articles[j], articles[i]];
    }

    // Keep only the first 3
    const articlesToKeep = articles.slice(0, itemsCount);

    articles.forEach((article, index) => {
      if (index >= 3) {
        article.remove();
      }
    });
  });
})();
